import React from 'react';
import { track } from '../../tracking';

export function FilterDialogV2<FilterBasisType extends string | number>({
    filteredMap: filteredServicesMap,
    wholeMap: servicesMap,
    apply,
    additionalConfig,
    alternateNameMap = new Map(),
    containerStyle,
    wrapTitle = false,
}: {
    wholeMap: Set<FilterBasisType>;
    filteredMap: Set<FilterBasisType>;
    apply: (servicesMap: Set<FilterBasisType>) => void;
    additionalConfig?: Record<FilterBasisType, { count?: number; amount?: number }>;
    alternateNameMap?: Map<FilterBasisType, string>;
    containerStyle?: React.CSSProperties;
    wrapTitle?: boolean;
}): JSX.Element {
    const toggle = (s: FilterBasisType) => {
        if (filteredServicesMap.has(s)) {
            filteredServicesMap.delete(s);
            track('FILTER_SELECT', { label: `${s}`, action: 'removed' });
        } else {
            filteredServicesMap.add(s);
            track('FILTER_SELECT', { label: `${s}`, action: 'added' });
        }

        apply(new Set(filteredServicesMap));
    };

    return (
        <div
            style={containerStyle}
            onClick={(e) => {
                e.stopPropagation();
            }}
            className="absolute max-w-288 bg-white top-28 z-10 p-8 shadow-tight-4 rounded-8 z-50 max-h-304 overflow-auto"
        >
            <div className="w-full p-4 bg-white space-y-8">
                {servicesMap.size > 0 ? (
                    [...servicesMap].map((s) => (
                        <div
                            key={s}
                            onClick={(e) => {
                                toggle(s);
                                e.stopPropagation();
                            }}
                            className="flex items-center space-x-8 px-8 py-4 rounded-4 cursor-pointer"
                        >
                            <div>
                                <div className="flex flex-col items-center justify-center w-18 h-18">
                                    <div className="relative flex flex-col items-center justify-center w-full h-full rounded-2">
                                        <input
                                            type="checkbox"
                                            className="w-full h-full opacity-0"
                                            name="checkbox"
                                            checked={filteredServicesMap.has(s)}
                                        />
                                        <div className="absolute inset-0 checkbox-fill"></div>
                                        <svg
                                            width="28"
                                            height="28"
                                            viewBox="0 0 28 28"
                                            className="absolute hidden -top-3 -left-3 fill-white cursor-pointer absolute hidden -top-3 -left-3 fill-white"
                                            preserveAspectRatio="xMidYMid meet"
                                        >
                                            <path d="M10.0547 16.8125C10.2891 17.0469 10.6875 17.0469 10.9219 16.8125L17.8125 9.92188C18.0469 9.6875 18.0469 9.28906 17.8125 9.05469L16.9688 8.21094C16.7344 7.97656 16.3594 7.97656 16.125 8.21094L10.5 13.8359L7.85156 11.2109C7.61719 10.9766 7.24219 10.9766 7.00781 11.2109L6.16406 12.0547C5.92969 12.2891 5.92969 12.6875 6.16406 12.9219L10.0547 16.8125Z"></path>
                                        </svg>
                                    </div>
                                </div>
                            </div>
                            <div
                                style={{ width: 'calc(100% - 24px)' }}
                                className="flex items-center justify-between text-13 font-700 text-neutral-4"
                            >
                                <div className="flex items-center space-x-4 w-80p">
                                    <span
                                        title={`${alternateNameMap.get(s) ?? s}`}
                                        className={`${
                                            !wrapTitle ? 'whitespace-nowrap' : ''
                                        } max-w-full`}
                                    >
                                        {alternateNameMap.get(s) ?? s}
                                    </span>
                                    {additionalConfig && additionalConfig[s].count && (
                                        <span>({additionalConfig[s].count})</span>
                                    )}
                                </div>
                                {additionalConfig && additionalConfig[s].amount && (
                                    <div className="pl-12 text-13 font-700 text-neutral-4">
                                        (₹{additionalConfig[s].amount?.toLocaleString('en-IN')})
                                    </div>
                                )}
                            </div>
                        </div>
                    ))
                ) : (
                    <span className="text-13 font-700 text-neutral-4 truncate">
                        Insufficient data
                    </span>
                )}
            </div>
        </div>
    );
}
